var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.loginData.token)?_c('Login',{attrs:{"loginData":_vm.loginData},on:{"update:loginData":function($event){_vm.loginData=$event},"update:login-data":function($event){_vm.loginData=$event}}}):_c('Connecting',{on:{"callbackFun":_vm.callbackFun}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }